<template>
    <div class="news-container">
        <div v-if="props.data && props.data.length > 0" class="news-content flex-start">
            <div
                class="left-wrap pointer"
                v-link="getDetailLink(activeInfo)"
                @click="goDetail(activeInfo)"
            >
                <LazyImage :src="activeInfo.coverUrl || defaultNewsImg" class-name="news-img" />
                <div class="header-bg">
                    <p class="header overflow-ellipsis" :title="activeInfo.contentTitle">
                        <span class="header-text-icon"></span>
                        <span>{{ activeInfo.contentTitle }}</span>
                    </p>
                </div>
            </div>
            <ul class="right-wrap" v-if="props.data.length > 1">
                <li
                    v-for="item in props.data.slice(0, 6)"
                    :key="item.contentId"
                    :class="[
                        'news-item',
                        'flex-start',
                        'pointer',
                        { active: item.contentId === activeInfo.contentId },
                    ]"
                    @click="goDetail(item)"
                    @mouseenter="onHover(item)"
                >
                    <p class="news-text overflow-ellipsis" :title="item.contentTitle">
                        <span v-link="getDetailLink(item)">{{ item.contentTitle }}</span>
                    </p>
                    <p class="light-gray-font-color">{{ item.publishTime }}</p>
                </li>
            </ul>
        </div>
        <BigNoData class="mar-top49" v-else url="no-news@2x.png" info="暂无资讯，静等上新" />
    </div>
</template>

<script setup>
import BigNoData from '@/components/no-data.vue';
import LazyImage from '@/components/lazy-image/lazy-image.vue';
import { goNewsDetail, getLink } from '@/lib/tools.js';
import { computed, ref, watch } from 'vue';

// const defaultNewsImg = 'https://srt-read-online.3ren.cn/basebusiness/material/20221102/16673627738023vUnoocsyi002.jpg'
const defaultNewsImg =
    'https://srt-read-online.3ren.cn/basebusiness/material/20230323/1679552862182QSZQebLxir000.png';

const props = defineProps({
    data: {
        // 新闻咨询列表
        type: Array,
        default: () => [],
    },
});

// 当前激活的公告item
const activeInfo = ref({});

// 跳转新闻详情页
function goDetail(info) {
    goNewsDetail(info, 'informationDetail');
}

function getDetailLink(info) {
    return getLink(info, 'informationDetail');
}

function onHover(info) {
    activeInfo.value = info;
}

watch(
    () => props.data,
    val => {
        if (val && val.length) {
            activeInfo.value = val[0];
        }
    },
    {
        deep: true,
        immediate: true,
    },
);
</script>

<style lang="scss" scoped>
.news-container {
    margin-top: 26px;
    .news-content {
        .left-wrap {
            position: relative;
            width: 373px;
            height: 210px;
            background: #f7f9fa;
            .news-img {
                width: 373px;
                height: 210px;
                border-radius: 4px;
            }
            .header-bg {
                position: absolute;
                bottom: 0;
                width: 100%;
                height: 70px;
                background: linear-gradient(360deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%);
                border-radius: 0px 0px 4px 4px;
                .header {
                    font-size: 16px;
                    color: #ffffff;
                    font-weight: bold;
                    line-height: 1.5;
                    margin-top: 26px;
                    padding-left: 33px;
                    padding-right: 20px;
                    position: relative;
                    // display: flex;
                    &:hover {
                        color: var(--home-main-color);
                    }
                    .header-text-icon {
                        display: inline-block;
                        position: absolute;
                        height: 16px;
                        width: 3px;
                        background-color: var(--home-main-color);
                        left: 20px;
                        top: 4px;
                    }
                }
            }
        }
        .right-wrap {
            flex: 1;
            height: 210px;
            display: block;
            overflow: hidden;
            .news-item {
                font-size: 14px;
                color: var(--srt-color-black);
                box-sizing: border-box;
                margin: 5px 0 0 20px;
                line-height: 1.5;
                &.active {
                    p {
                        color: var(--home-main-color);
                    }
                }
                .news-text {
                    width: 100%;
                    margin-right: 24px;
                }
                &::before {
                    content: '';
                    display: inline-block;
                    height: 14px;
                    width: 3px;
                    background-color: var(--home-main-color);
                    margin-right: 7px;
                }
                &:nth-child(n + 2) {
                    margin: 16px 0 0 20px;
                }
            }
        }
    }
    .mar-top49 {
        margin-top: 49px;
    }
}
</style>
